<script>
import TileWMS from 'ol/source/TileWMS'
import Overlay from 'ol/Overlay'
import parseStyle from '../ol-map/utils/style'
import { fromLonLat } from 'ol/proj';
export default {
    name: 'ol-overlayer',

    inject: ['getMap'],

    props: {
        position: {
            type: Array,
            default: undefined
        },
        popClass: {
            type: String,
            default: 'pop-content'
        },
        positioning: {
            type: String,
            default: 'bottom-center'
        },
        stopEvent: {
            type: Boolean,
            default: false
        },
        insertFirst: {
            type: Boolean,
            default: false
        },
        autoPan : {
            type: Boolean,
            default: false
        },
        offset: {
            type: Array,
            default() {
                return [0, 0]
            }
        },

    },

    watch: {
        position(pos) {
            if (pos.length > 0) {
                this.overlay.setPosition(pos)
            } else {
                this.overlay.setPosition(undefined)
            }
        },
    },

    data() {
        return {
            overlay: null
        }
    },

    mounted() {
        
        this.overlay = new Overlay({
            element: document.getElementById(this.popClass),
            offset: this.offset,
            position: undefined,
            positioning: this.positioning,
            stopEvent: this.stopEvent,
            insertFirst: this.insertFirst,
            autoPan: this.autoPan,
        })
        this.getMap(map => {
            map.addOverlay(this.overlay)
        })

    },

    beforeDestroy() {
        this.overlay = null
    },

    render() {
        return null
    }
}
</script>
